// webserver/src/components/GoogleHome/AssistantQuery.js

import React, { useState } from 'react';
import axios from 'axios';

const AssistantQuery = ({ siteId }) => {
  const [query, setQuery] = useState('');
  const [responseText, setResponseText] = useState('');

  const sendQuery = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/googlehome/assistant-query`,
        { query, siteId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setResponseText(JSON.stringify(res.data.response, null, 2));
    } catch (error) {
      console.error('Error sending assistant query:', error);
      setResponseText('Error sending assistant query: ' + error.message);
    }
  };

  return (
    <div style={{ border: '1px solid #ccc', padding: '1rem', marginTop: '1rem' }}>
      <h3>Assistant Query Tester</h3>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Enter your command, e.g. 'Turn on living room TV'"
        style={{ width: '80%', padding: '0.5rem' }}
      />
      <button onClick={sendQuery} style={{ marginLeft: '1rem', padding: '0.5rem 1rem' }}>
        Hey Google
      </button>
      {responseText && (
        <pre style={{ marginTop: '1rem', backgroundColor: '#eee', padding: '0.5rem' }}>
          {responseText}
        </pre>
      )}
    </div>
  );
};

export default AssistantQuery;
